// C8 · المتابعة الإدارية (HR Action Center) i18n namespace. Merged into the top-level
// ar/en messages by i18n.ts (require.context over ./screens). Full ar/en parity for
// every key the admin-followup.vue view binds via $t('admin-followup.*').
module.exports = {
  ar: {
    'admin-followup': {
      title: 'المتابعة الإدارية',
      crumb: 'إجراءات الـ HR',
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء تنفيذ العملية',
      empty: 'لا توجد إجراءات في السجل',
      searchPlaceholder: 'ابحث باسم الموظف…',
      actionCenter: 'مركز الإجراءات',
      quickToggle: 'تغيير الحالة السريع',
      quick: {
        searching: 'جارٍ البحث…',
        noEmployees: 'لسه مفيش موظفين مسجّلين. ضيف موظفين من شاشة «الموظفين» وهيظهروا هنا علشان تغيّر حالتهم.',
        searchToFind: 'دي أول {n} موظفين. لو الموظف اللي عايزه مش هنا، اكتب اسمه أو رقم الكارت في البحث فوق — البحث بيدوّر في كل موظفي الشركة، مش في الـ{n} دول بس.',
        searchEmpty: 'مفيش موظف مطابق للبحث. جرّب جزء من الاسم أو رقم الكارت.',
      },
      monthSummary: 'ملخّص الشهر',
      logTitle: 'سجل المتابعة (Audit Log)',
      recentBadge: 'آخر {n} إجراءات',
      form: {
        employee: 'الموظف',
        employeePlaceholder: 'اختر الموظف…',
        action: 'نوع الإجراء',
        lastWorkDay: 'التاريخ (آخر يوم عمل)',
        note: 'السبب / الملاحظة',
        notePlaceholder: 'سبب الإجراء أو ملاحظة اختيارية…',
        execute: 'تنفيذ الإجراء',
        cancel: 'إلغاء',
        saving: 'جارٍ التنفيذ…',
        employeeRequired: 'يجب اختيار الموظف أولاً',
        dateRequired: 'يجب تحديد تاريخ آخر يوم عمل',
        coverageEndsHint: 'التغطية تنتهي في اليوم التالي لآخر يوم عمل',
        success: 'تم تنفيذ الإجراء وتسجيله في السجل',
        statusChanged: 'تم تحديث حالة {name}',
      },
      actions: {
        activate: 'تفعيل',
        suspend: 'إيقاف',
        leave: 'تسجيل مغادرة',
        edit: 'تعديل بيانات',
      },
      actionLog: {
        activate: 'تفعيل',
        suspend: 'إيقاف',
        leave: 'مغادرة',
        edit: 'تعديل',
      },
      toggle: {
        activate: 'تفعيل',
        suspend: 'إيقاف',
      },
      kpi: {
        leavers: 'مغادرين',
        suspensions: 'إيقاف',
        edits: 'تعديلات',
      },
      statuses: {
        active: 'نشط',
        suspended: 'موقوف',
        left: 'مغادر',
      },
      cols: {
        employee: 'الموظف',
        action: 'الإجراء',
        date: 'التاريخ',
        by: 'بواسطة',
        note: 'ملاحظة',
      },
    },
  },
  en: {
    'admin-followup': {
      title: 'HR Follow-up',
      crumb: 'HR actions',
      loading: 'Loading…',
      error: 'Something went wrong while running the action',
      empty: 'No actions in the log',
      searchPlaceholder: 'Search by employee name…',
      actionCenter: 'Action center',
      quickToggle: 'Quick status change',
      quick: {
        searching: 'Searching…',
        noEmployees: 'No employees are registered yet. Add some from the Employees screen and they will appear here for a quick status change.',
        searchToFind: 'These are the first {n} employees. If the one you want is not here, type their name or card number in the search above — it searches every employee in the company, not just these {n}.',
        searchEmpty: 'No employee matches that search. Try part of the name, or the card number.',
      },
      monthSummary: 'This month',
      logTitle: 'Follow-up log (Audit Log)',
      recentBadge: 'Last {n} actions',
      form: {
        employee: 'Employee',
        employeePlaceholder: 'Select employee…',
        action: 'Action type',
        lastWorkDay: 'Date (last working day)',
        note: 'Reason / note',
        notePlaceholder: 'Reason for the action or an optional note…',
        execute: 'Run action',
        cancel: 'Cancel',
        saving: 'Running…',
        employeeRequired: 'Please select an employee first',
        dateRequired: 'Please set the last working day',
        coverageEndsHint: 'Coverage ends the day after the last working day.',
        success: 'Action executed and recorded in the log',
        statusChanged: 'Updated status of {name}',
      },
      actions: {
        activate: 'Activate',
        suspend: 'Suspend',
        leave: 'Record leave',
        edit: 'Edit details',
      },
      actionLog: {
        activate: 'Activated',
        suspend: 'Suspended',
        leave: 'Left',
        edit: 'Edited',
      },
      toggle: {
        activate: 'Activate',
        suspend: 'Suspend',
      },
      kpi: {
        leavers: 'Leavers',
        suspensions: 'Suspensions',
        edits: 'Edits',
      },
      statuses: {
        active: 'Active',
        suspended: 'Suspended',
        left: 'Left',
      },
      cols: {
        employee: 'Employee',
        action: 'Action',
        date: 'Date',
        by: 'By',
        note: 'Note',
      },
    },
  },
};
